import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const CustomSkelton = ({
    variant = "rectangular",
    fontSize = '1rem',
    width = '100%',
    height = 140,
    borderRadius = '12px',
    marginRight = '20px',
}) => {
    return (
        <Skeleton
            variant={variant}
            animation="wave"
            width={width}
            height={height}
            sx={{
                fontSize,
                borderRadius,
                marginRight,
            }}
        />
    );
};

export default CustomSkelton;
